// eslint-disable  react-hooks/rules-of-hooks
import store, { MainSelector, RootStateType } from "@Store/store";
import { IUserData } from "@Interfaces";

export const getUserData = (): Promise<IUserData> => {
    const {
        auth: { user },
    } = store.getState();

    return new Promise((resolve, reject) => {
        if (user) {
            resolve(user);
        } else {
            reject("");
        }
    });
};

const selectIsUserAuthorized = () =>
    MainSelector(
        ({ auth: { isAuthenticated } }: RootStateType) => isAuthenticated
    );

export default {
    getUserData,
    selectIsUserAuthorized,
};
